import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const CDN = 'https://cdn.prod.website-files.com/68ce578c9359063e607d9477';

// ─── Design tokens ────────────────────────────────────────────────────────────
const C = {
  bo600:   '#2c7cb2',
  bo500:   '#266b99',
  bo100:   '#e0f2fe',
  bo25:    '#f0f9ff',
  grey900: '#101828',
  grey500: '#667085',
  grey300: '#d0d5dd',
  grey100: '#f2f4f7',
  primary400: '#811fd6',
};

// ─── Assets ───────────────────────────────────────────────────────────────────
const LOGO         = `${CDN}/68ce5e6f3114529d2b6ffeec_Vector%20(1).png`;
const HERO_IMG     = `${CDN}/68cec4227a6cbec1fedc3126_Group%20539.png`;
const DASHBOARD    = `${CDN}/68cec881e2afc590d7da69f8_Group%20539%20(1).png`;

const PARTNER_LOGOS = [
  `${CDN}/68d149351f0cdeabd19e410d_Frame%203954.png`,
  `${CDN}/68d149340236d623a5cf890a_Frame%203951.png`,
  `${CDN}/68d149340236d623a5cf8907_Frame%203949.png`,
  `${CDN}/68d1493417bae50d4821bc3a_Frame%203946.png`,
  `${CDN}/68d4fcce52e1990acd7c5b68_Frame%203956.png`,
  `${CDN}/68d14934b10a1070c12908a4_Frame%203955.png`,
  `${CDN}/68d14934eb6367a3f8211e0e_Frame%203950.png`,
  `${CDN}/68d149343318c8d4c2c68d8f_Frame%203947.png`,
  `${CDN}/68d149348ad2377ed7f892f6_Frame%203948.png`,
  `${CDN}/68d149252c9dc3c4c85fc6ec_Frame%203952%20(1).png`,
  `${CDN}/68d14d58e4de88224bcdb059_Frame%203953.png`,
];

const SUPPORTER_LOGOS = [
  { src: `${CDN}/68cecc4d3bbd011dcc64e21b_image%2025.png`, w: 149, h: 40 },
  { src: `${CDN}/68cecc4d13aa2def2ae71acf_image%2024.png`, w: 67,  h: 48 },
  { src: `${CDN}/68cecc4d5873a58c1b4398d8_image%2026.png`, w: 88,  h: 48 },
];

const FEATURES = [
  {
    icon: `${CDN}/68cec6514459ec3d01c98709_CalendarBlank.png`,
    title: 'Planifier sa rotation',
    desc: 'Faciliter le renouvellement, assurer de la nouveauté',
  },
  {
    icon: `${CDN}/68cec65101c4e0ebcfeb0f7d_Users%20(1).png`,
    title: "Mesurer sa qualité d'ouverture",
    desc: 'La bonne difficulté, le bon style à tous les niveaux',
  },
  {
    icon: `${CDN}/68cec6518681bbb041725ed5_ChartBar%20(1).png`,
    title: 'Récolter des retours qualifiés',
    desc: 'Analyser la pratique de ses clients et accéder à leurs commentaires',
  },
];

const SOCIAL_LINKS = [
  { href: 'https://www.instagram.com/gaston_grimpe/',             icon: `${CDN}/68ceb5701f34e5a010f73ba5_Frame%201501.png` },
  { href: 'https://www.tiktok.com/@gaston_grimpe',                icon: `${CDN}/68ceb570319e6069aeda9275_Frame%201502.png` },
  { href: 'https://www.youtube.com/@gaston_grimpe/featured',      icon: `${CDN}/68ceb570d24863ab139118ba_Frame%201503.png` },
  { href: 'https://www.linkedin.com/company/gaston-grimpe/',      icon: `${CDN}/68ceb5702e3d642e1472c43e_Frame%201504.png` },
];

const DEMO_URL = 'https://calendly.com/jeremy-gaston/un-coup-d-oeil-chez-gaston';

// ─── Component ────────────────────────────────────────────────────────────────
const ProPage: React.FC = () => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    document.title = 'Gaston pour les salles – Planifier, mesurer, optimiser';
  }, []);

  return (
    <div style={{ width: '100%', fontFamily: "'Nunito Sans', sans-serif", overflowX: 'hidden', maxWidth: '100vw' }}>

      <style>{`
        /* Marquee */
        @keyframes pro-marquee { 0% { transform: translateX(0); } 100% { transform: translateX(-50%); } }
        .pro-marquee-track { display: flex; animation: pro-marquee 30s linear infinite; width: max-content; align-items: center; }
        .pro-marquee-track img { height: 70px; margin: 0 28px; object-fit: contain; }

        /* Nav links */
        .pro-nav-link { color: #fff; font-family: 'Nunito Sans', sans-serif; font-size: 16px; font-weight: 600;
          line-height: 24px; padding: 5px 10px; text-decoration: none; }
        .pro-nav-link:hover { opacity: .78; }

        /* Toggle */
        .pro-toggle-btn { border: none; border-radius: 30px; padding: 8px 20px; cursor: pointer;
          display: flex; flex-direction: column; align-items: center; background: transparent; transition: background .15s; }
        .pro-toggle-btn.active  { background: #fff; }
        .pro-toggle-btn.inactive { background: transparent; }
        .pro-toggle-label    { font-family: 'Nohemi', sans-serif; font-size: 14px; font-weight: 500; line-height: 18px; }
        .pro-toggle-sublabel { font-family: 'Nunito Sans', sans-serif; font-size: 12px; font-weight: 600; line-height: 14px; }
        .pro-toggle-btn.active   .pro-toggle-label    { color: ${C.bo600}; }
        .pro-toggle-btn.active   .pro-toggle-sublabel { color: ${C.bo600}; }
        .pro-toggle-btn.inactive .pro-toggle-label    { color: #fff; }
        .pro-toggle-btn.inactive .pro-toggle-sublabel { color: #fff; }

        /* Buttons */
        .pro-btn-primary { background: #fff; color: ${C.bo600}; border: none; border-radius: 8px;
          padding: 12px 16px; font-family: 'Nunito Sans', sans-serif; font-size: 16px; font-weight: 700;
          line-height: 24px; cursor: pointer; text-decoration: none; display: inline-block;
          transition: background .2s; }
        .pro-btn-primary:hover { background: ${C.bo100}; }
        .pro-btn-big { padding: 28px 32px; font-size: 22px; line-height: 30px; display: inline-block;
          border-radius: 8px; background: #fff; color: ${C.bo600}; font-family: 'Nunito Sans', sans-serif;
          font-weight: 700; text-decoration: none; transition: background .2s; margin-top: 24px; }
        .pro-btn-big:hover { background: ${C.bo100}; }

        /* Hamburger */
        .pro-hamburger { display: none; flex-direction: column; gap: 5px; background: none; border: none; cursor: pointer; padding: 4px; }
        .pro-hamburger span { display: block; width: 24px; height: 2px; background: #fff; border-radius: 2px; }

        /* Mobile menu */
        .pro-mobile-menu { display: none; position: fixed; top: 72px; left: 0; right: 0; z-index: 99;
          background: ${C.bo500}; flex-direction: column; padding: 8px 0; box-shadow: 0 8px 24px rgba(0,0,0,.18); }
        .pro-mobile-menu.open { display: flex; }
        .pro-mobile-menu a { color: #fff; font-family: 'Nunito Sans', sans-serif; font-size: 16px; font-weight: 600;
          padding: 14px 24px; text-decoration: none; border-bottom: 1px solid rgba(255,255,255,.1); }
        .pro-mobile-menu a:last-child { border-bottom: none; }
        .pro-mobile-menu a:hover { background: rgba(255,255,255,.1); }

        /* Hero grid */
        .pro-hero-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 40px; align-items: center; width: 100%; max-width: 1100px; }

        /* Responsive */
        @media (max-width: 991px) {
          .pro-hero-grid  { grid-template-columns: 1fr !important; }
          .pro-hero-right { display: none !important; }
          .pro-feat-grid  { grid-template-columns: 1fr 1fr !important; }
        }
        @media (max-width: 767px) {
          .pro-nav-links  { display: none !important; }
          .pro-hamburger  { display: flex !important; }
          .pro-hero-section { padding: 48px 20px !important; min-height: auto !important; max-height: none !important; }
          .pro-hero-h1    { font-size: 2rem !important; line-height: 2.5rem !important; }
          .pro-hero-sub   { font-size: 1rem !important; line-height: 1.5rem !important; }
          .pro-feat-grid  { grid-template-columns: 1fr !important; }
          .pro-toggle     { flex-direction: column !important; width: 100% !important; }
          .pro-toggle-btn { width: 100% !important; }
          .pro-btn-big    { padding: 14px 16px !important; font-size: 1rem !important; }
          .pro-supporters { flex-direction: column !important; gap: 32px !important; }
          .pro-section-pad { padding-left: 16px !important; padding-right: 16px !important; }
        }
      `}</style>

      {/* ── NAVBAR ── */}
      <nav style={{
        backgroundColor: C.bo600, position: 'fixed', top: 0, left: 0, right: 0, zIndex: 100,
        height: '72px', display: 'flex', alignItems: 'center', padding: '0 20px', boxSizing: 'border-box',
      }}>
        <div style={{ width: '100%', maxWidth: '1100px', margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <a href="/">
            <img src={LOGO} alt="Gaston" style={{ width: '120px', display: 'block' }} />
          </a>
          <div className="pro-nav-links" style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            <a className="pro-nav-link" href="https://rotpunkttest.fr/monthly-challenge/" target="_blank" rel="noopener noreferrer">Classements</a>
            <a className="pro-nav-link" href="https://rotpunkttest.fr/login-pro" target="_blank" rel="noopener noreferrer">Mon espace ouvreur</a>
            <a className="pro-nav-link" href={DEMO_URL} target="_blank" rel="noopener noreferrer">Nous rencontrer</a>
          </div>
          <button className="pro-hamburger" onClick={() => setMenuOpen(o => !o)} aria-label="Menu">
            <span /><span /><span />
          </button>
        </div>
      </nav>

      {/* Mobile dropdown */}
      <div className={`pro-mobile-menu${menuOpen ? ' open' : ''}`}>
        <a href="https://rotpunkttest.fr/monthly-challenge/" target="_blank" rel="noopener noreferrer" onClick={() => setMenuOpen(false)}>Classements</a>
        <a href="https://rotpunkttest.fr/login-pro" target="_blank" rel="noopener noreferrer" onClick={() => setMenuOpen(false)}>Mon espace ouvreur</a>
        <a href={DEMO_URL} target="_blank" rel="noopener noreferrer" onClick={() => setMenuOpen(false)}>Nous rencontrer</a>
      </div>

      <main style={{ marginTop: '72px', overflowX: 'hidden' }}>

        {/* ── HERO ── */}
        <section
          className="pro-hero-section"
          style={{
            background: `radial-gradient(circle closest-corner at 60% 100%, #98d4fc, ${C.bo600})`,
            minHeight: 'calc(100vh - 72px)', maxHeight: '928px',
            padding: '80px 30px',
            display: 'flex', justifyContent: 'center', alignItems: 'center',
            boxSizing: 'border-box', overflow: 'hidden',
          }}
        >
          <div className="pro-hero-grid">
            {/* Left */}
            <div>
              {/* Toggle */}
              <div style={{
                display: 'inline-flex', border: '1px solid rgba(255,255,255,.4)',
                backgroundColor: 'rgba(255,255,255,.25)', borderRadius: '40px',
                padding: '8px', marginBottom: '32px',
              }}>
                <button className="pro-toggle-btn inactive" onClick={() => navigate('/')}>
                  <span className="pro-toggle-label">Grimpeur</span>
                  <span className="pro-toggle-sublabel">Je veux progresser</span>
                </button>
                <button className="pro-toggle-btn active">
                  <span className="pro-toggle-label">Salle</span>
                  <span className="pro-toggle-sublabel">Je gère une salle</span>
                </button>
              </div>

              <h1 className="pro-hero-h1" style={{
                fontFamily: "'Nohemi', sans-serif",
                fontSize: '48px', fontWeight: 600, lineHeight: '56px',
                color: '#fff', margin: '0 0 16px 0',
              }}>
                L'ouverture juste à portée de clic
              </h1>

              <p className="pro-hero-sub" style={{
                fontFamily: "'Nunito Sans', sans-serif",
                fontSize: '20px', fontWeight: 300, lineHeight: '26px',
                color: '#fff', marginBottom: '32px',
              }}>
                Planifier son ouverture et l'optimiser avec des retours clients qualifiés
              </p>

              <a
                className="pro-btn-primary"
                href={DEMO_URL}
                target="_blank" rel="noopener noreferrer"
              >
                Je planifie ma démo avec Gaston
              </a>
            </div>

            {/* Right */}
            <div className="pro-hero-right" style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-end' }}>
              <img
                src={HERO_IMG}
                alt="Interface Gaston pour les salles"
                style={{ width: '110%', maxWidth: '560px', display: 'block' }}
              />
            </div>
          </div>
        </section>

        {/* ── PARTNER LOGOS MARQUEE ── */}
        <div style={{ backgroundColor: '#fff', padding: '48px 0' }}>
          <h2 style={{
            fontFamily: "'Nohemi', sans-serif",
            fontSize: '26px', fontWeight: 500, color: C.grey900,
            textAlign: 'center', marginBottom: '32px',
            padding: '0 30px',
          }}>
            Nos salles partenaires
          </h2>
          <div style={{ overflow: 'hidden', width: '100%' }}>
            <div className="pro-marquee-track">
              {[...PARTNER_LOGOS, ...PARTNER_LOGOS].map((src, i) => (
                <img key={i} src={src} alt="Salle partenaire" />
              ))}
            </div>
          </div>
        </div>

        {/* ── FEATURES ── */}
        <section
          id="features-pro"
          className="pro-section-pad"
          style={{
            background: `linear-gradient(6deg, ${C.bo600} 79%, #fff)`,
            padding: '64px 30px',
          }}
        >
          <div style={{ maxWidth: '1100px', margin: '0 auto', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <h2 style={{
              fontFamily: "'Nohemi', sans-serif",
              fontSize: '40px', fontWeight: 600, lineHeight: '48px',
              color: '#fff', marginBottom: '32px', textAlign: 'center',
            }}>
              Planifier, mesurer et optimiser
            </h2>

            {/* 3-col feature cards */}
            <div
              className="pro-feat-grid"
              style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '24px', width: '100%', marginBottom: '40px' }}
            >
              {FEATURES.map((f, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                  <img src={f.icon} alt="" style={{ width: '32px', height: '32px', flexShrink: 0, marginTop: '2px' }} />
                  <div>
                    <p style={{
                      fontFamily: "'Nunito Sans', sans-serif",
                      fontSize: '18px', fontWeight: 700, lineHeight: '24px',
                      color: '#fff', margin: '0 0 6px 0',
                    }}>
                      {f.title}
                    </p>
                    <p style={{
                      fontFamily: "'Nunito Sans', sans-serif",
                      fontSize: '16px', fontWeight: 300, lineHeight: '24px',
                      color: 'rgba(255,255,255,.9)', margin: 0,
                    }}>
                      {f.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            {/* Dashboard screenshot */}
            <img
              src={DASHBOARD}
              alt="Dashboard Gaston"
              style={{ width: '100%', maxWidth: '1000px', borderRadius: '12px', display: 'block', boxShadow: '0 8px 40px rgba(0,0,0,.18)' }}
            />

            {/* Big CTA */}
            <a
              className="pro-btn-big"
              href={DEMO_URL}
              target="_blank" rel="noopener noreferrer"
              style={{ marginTop: '40px', marginBottom: '16px' }}
            >
              Je planifie ma démo avec Gaston
            </a>

            {/* Newsletter link */}
            <a
              href="https://instagram.us12.list-manage.com/subscribe?u=ba53c95a14502d2315710bfef&id=fb9263572a"
              target="_blank" rel="noopener noreferrer"
              style={{
                fontFamily: "'Nunito Sans', sans-serif",
                fontSize: '18px', fontWeight: 300, lineHeight: '26px',
                color: '#fff', textDecoration: 'underline',
              }}
            >
              Je veux recevoir la newsletter des pros de la verticalité
            </a>
          </div>
        </section>

        {/* ── SUPPORTERS ── */}
        <section className="pro-section-pad" style={{ padding: '64px 30px', backgroundColor: '#fff' }}>
          <div style={{ maxWidth: '1100px', margin: '0 auto', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <h2 style={{
              fontFamily: "'Nohemi', sans-serif",
              fontSize: '26px', fontWeight: 500, lineHeight: '32px',
              color: C.grey900, marginBottom: '32px', textAlign: 'center',
            }}>
              Ils nous soutiennent
            </h2>
            <div className="pro-supporters" style={{ display: 'flex', alignItems: 'center', gap: '96px', flexWrap: 'wrap', justifyContent: 'center' }}>
              {SUPPORTER_LOGOS.map((s, i) => (
                <img key={i} src={s.src} alt="Partenaire" style={{ width: s.w, height: s.h, objectFit: 'contain' }} />
              ))}
            </div>
          </div>
        </section>

        {/* ── FOOTER ── */}
        <footer style={{
          backgroundColor: C.bo600,
          padding: '48px 30px',
        }}>
          <div style={{ maxWidth: '1100px', margin: '0 auto', display: 'flex', flexDirection: 'column', gap: '32px', alignItems: 'center' }}>
            {/* Social icons */}
            <div style={{ display: 'flex', gap: '32px', alignItems: 'center', justifyContent: 'center' }}>
              {SOCIAL_LINKS.map((s, i) => (
                <a key={i} href={s.href} target="_blank" rel="noopener noreferrer">
                  <img src={s.icon} alt="" style={{ width: '40px', height: '40px', display: 'block' }} />
                </a>
              ))}
            </div>
            {/* Legal links */}
            <div style={{ display: 'flex', gap: '24px', flexWrap: 'wrap', justifyContent: 'center' }}>
              <a href="https://rotpunkttest.fr/general-conditions/" target="_blank" rel="noopener noreferrer"
                style={{ color: '#fff', fontFamily: "'Nunito Sans', sans-serif", fontSize: '16px', fontWeight: 700, textDecoration: 'none' }}>
                Mentions légales
              </a>
              <a href="https://rotpunkttest.fr/personnal-data/" target="_blank" rel="noopener noreferrer"
                style={{ color: '#fff', fontFamily: "'Nunito Sans', sans-serif", fontSize: '16px', fontWeight: 700, textDecoration: 'none' }}>
                Confidentialité
              </a>
            </div>
          </div>
        </footer>

      </main>
    </div>
  );
};

export default ProPage;
